const data = [
  {
    roles: ["C-level", "IT", "Business Manager", "End user"],
    title: "Benefits of cloud",
    description:
      "There are five proven strategies to migrate to Oracle Cloud ERP. Migrate to simplify finance and operations, reduce business risk, close your books faster, and benefit from ongoing innovation—all with a total cost of ownership (TCO) that’s up to <a href='https://www.oracle.com/erp/move-on-premises-to-cloud/' target='_blank'>50% less than traditional on-premises ERP</a>.",
    image: "thumb1",
    cta_text: "Migrate to Oracle Fusion Cloud ERP ",
    url: "https://www.oracle.com/erp/oracle-vs-sap/migrate/",
  },
  {
    roles: ["C-level", "IT", "Business Manager", "End user"],
    title: "Optimize for adaptability",
    description:
      "In the industrial era, business was stable and change was mostly predictable. You optimized your company for efficiency. In the digital era, change is uncertain and continuous. You have to optimize for adaptability. Change can come from anywhere, including new products and technologies, disruptions, governance, social media (perception), employee and customer experience. Read the report about Oracle Fusion Cloud Applications, published in the SAP user magazine E3zine, showing how Gartner’s vision becomes a reality in Oracle’s Applications.",
    image: "thumb2",
    cta_text: "Read the whitepaper",
    url: "https://www.oracle.com/a/ocom/docs/applications/erp/composability-quick-wins-in-a-world-of-change.pdf ",
  },
  {
    roles: ["C-level", "IT", "Business Manager", "End user"],
    title: "Close your books faster",
    description:
      "Oracle closes its books faster than SAP. With the right data in your financial systems, not only can you close your books faster, but you can respond faster to changing demands and emerging opportunities in your business.",
    image: "thumb3",
    cta_text: "Read the blog",
    url: "https://blogs.oracle.com/modernfinance/post/why-oracle-closes-its-books-more-than-twice-as-fast-as-sap-and-workday",
  },
];

export default data;
